import { Box, DialogContent, DialogTitle } from "@mui/material";
import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IUpdateWorkOrderPoStatus } from "mobx-stores/_models/work-order-po/work-order-po";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateWorkOrderPoStatusSchema } from "../schema";

export const WorkOrderPoStatusManagement = observer(() => {
  const {
    workOrderPoManagement: {
      openUpdateStatus,
      setProp,
      getWorkOrderPoDetail,
      workOrderPoDetail,
    },
    catalogueStore: {
      workOrderPoStatuses,
      getWorkOrderPoStatuses,
      cataloguesToOptionItems,
    },
  } = useStores();

  const {
    form: { controls, isValid },
    getControl,
    setDefaults,
    submitHandler,
  } = useForm<IUpdateWorkOrderPoStatus>(getUpdateWorkOrderPoStatusSchema(), {
    statusId: "",
    isCompensating: false,
  });

  const onCloseHandler = useCallback(() => {
    setProp("openUpdateStatus", false);
  }, [setProp]);

  useEffect(() => {
    if (workOrderPoDetail) {
      setDefaults({
        statusId: workOrderPoDetail.statusId,
        isCompensating: workOrderPoDetail.isCompensating || false,
      });
    }
  }, [setDefaults, workOrderPoDetail]);

  useEffect(() => {
    getWorkOrderPoStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (workOrderPoStatuses) {
      getControl("statusId").setProp(
        "optionItems",
        cataloguesToOptionItems(workOrderPoStatuses),
      );
    }
  }, [cataloguesToOptionItems, getControl, workOrderPoStatuses]);

  const saveHandler = useCallback(
    async (data: IUpdateWorkOrderPoStatus) => {
      try {
        if (!workOrderPoDetail?.id) return;

        await workOrderPoBusiness.updateStatus(workOrderPoDetail.id, data);
        await getWorkOrderPoDetail(workOrderPoDetail.id);
        onCloseHandler();
      } catch (ex) {
        console.error(ex);
      }
    },
    [getWorkOrderPoDetail, onCloseHandler, workOrderPoDetail?.id],
  );

  return (
    <DialogForm
      open={openUpdateStatus}
      fullWidth
      maxWidth={"sm"}
      onClose={onCloseHandler}
      onCancelBtnClicked={onCloseHandler}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Cập nhật trạng thái lệnh sản xuất</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
